'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTypingTimeoutIdForAgentInThread = undefined;

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getTypingTimeoutIdForAgentInThread = exports.getTypingTimeoutIdForAgentInThread = function getTypingTimeoutIdForAgentInThread(_ref) {
  var threadId = _ref.threadId,
      agentId = _ref.agentId,
      agentTypingStates = _ref.agentTypingStates;
  return (0, _getIn2.default)([threadId, agentId], agentTypingStates);
};


//////////////////
// WEBPACK FOOTER
// ./js/typing-indicators/operators/getTypingTimeoutIdForAgentInThread.js
// module id = 267
// module chunks = 2 3